import { MyMoneyState } from '../store/my-money';
import { useAppSelector } from './store';

export const useMyMoneyData = () => {
  return useAppSelector<MyMoneyState>((state) => state.myMoney);
};
